export default __webpack_public_path__ + "static/media/logo-header.cab9e292.png";